'use client';

import { useEffect, useState } from 'react';
import { useLocale } from 'next-intl';
import { birKezYenile, dagitimKaymasiMi, dizineAlmaIsaretiKoy } from '@/lib/error/deploy-skew';

/**
 * Sayfa icerigi coktugunde ust ve alt bilgi yerinde kalir, ortaya bu kutu gelir.
 * Bu hal 200 ile cizildigi icin arama motoru dizine alabiliyordu; simdi noindex
 * isareti konur. Dagitim kaymasi hatalarinda (eski sayfa + yeni paketler) sayfa
 * bir kez kendini yeniler, kullanici hic hata gormez.
 */
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const locale = useLocale();
  const en = locale === 'en';
  const [yenileniyor, setYenileniyor] = useState(false);

  useEffect(() => {
    console.error(error);
    if (dagitimKaymasiMi(error) && birKezYenile()) {
      setYenileniyor(true);
      return;
    }
    return dizineAlmaIsaretiKoy();
  }, [error]);

  if (yenileniyor) {
    return (
      <div className="flex items-center justify-center min-h-[50vh] px-4 text-sm text-navy-soft">
        {en ? 'Refreshing...' : 'Yenileniyor...'}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4 text-center">
      <h2 className="text-2xl font-bold mb-3 text-navy dark:text-white">
        {en ? 'Something went wrong' : 'Bir şeyler yanlış gitti'}
      </h2>
      <p className="text-muted-foreground mb-6 max-w-md">
        {en
          ? 'The page could not be displayed. Please try again; if it keeps happening, return to the home page.'
          : 'Sayfa görüntülenemedi. Tekrar deneyin; sorun sürerse ana sayfaya dönün.'}
      </p>
      <div className="flex items-center gap-4">
        <button
          type="button"
          className="px-4 py-2 bg-brand text-white rounded-md hover:bg-brand/90 transition-colors text-sm font-bold"
          onClick={() => reset()}
        >
          {en ? 'Try again' : 'Tekrar Dene'}
        </button>
        <a href={`/${locale}`} className="text-sm font-semibold text-navy dark:text-white hover:underline">
          {en ? 'Home page' : 'Ana sayfa'}
        </a>
      </div>
      {error?.digest && <p className="mt-6 text-[11px] text-slate-400">{error.digest}</p>}
    </div>
  );
}
